import { render, staticRenderFns } from "./GrowthDiseaseImageInputComponent.vue?vue&type=template&id=0824cc1a&"
import script from "./GrowthDiseaseImageInputComponent.vue?vue&type=script&lang=js&"
export * from "./GrowthDiseaseImageInputComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports